// extracted by mini-css-extract-plugin
module.exports = {"modal":"highlight_modal__1pObc","root":"highlight_root__2iO-S","close":"highlight_close__36nms","title":"highlight_title__3BT2N"};